import React from 'react';
import { getComputedCSSVariable } from '../../../utils/cssVariableHelpers';

export type PriceLinkType = {url: string, label: string}
interface PriceLinkProps {
  priceUrl: PriceLinkType;
}

const PriceLink: React.FC<PriceLinkProps> = ({ priceUrl }) => {
  const { url, label } = priceUrl;
  return (
    <a
      href={url}
      className="btn btn-sm rounded-pill text-center d-flex my-3 px-3 align-items-center"
      style={{
        gap: '0.5rem',
        backgroundColor: getComputedCSSVariable('blue-200'),
        borderColor: getComputedCSSVariable('blue-200'),
        fontSize: '1rem',
        margin: '0 0.125rem',
      }}
    >
      <img
        src="/images/price.svg"
        style={{
          height: '1.5rem',
          width: '1.5rem',
        }}
        alt="price tag icon"
      />
      {label}
    </a>
  );
};

export default PriceLink;
